import * as React from 'react';
import { post } from '../../../model/post';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography, Grid, CircularProgress } from '@material-ui/core';
import { Down } from '../../../ui-components/Icons';
import { VoteGraph } from './VoteGraph'
import Preview from './preview';
import { WithMediaQuery, IMediaQueryProps } from '../../../layout/withMediaQuery';
import { Votes } from './Votes';

interface Iprops extends IMediaQueryProps {
    key: string;
    post: post;
    getContent: (post: post) => any;
    classes: any;
    loadVotes: (idPost: string) => any;
    loadStatsVote: (idPost: string) => Promise<any>;
}

interface IState {
    expanded: boolean;
}

class Comp extends React.Component<Iprops, IState> {
    state = {
        expanded: false
    }

    ChangeExpanded = e => {
        if (this.props.post && !this.props.post.loaded) {
            this.props.getContent(this.props.post);
            this.loadVotes();
        }
        this.setState({ expanded: e });
    }
    fullScreenLayout = (props: Iprops) => {
        const { post } = props;
        return (
            <Grid container className={props.classes.listItemContainer}>
                <Grid item xs={1}>
                    <div className={props.classes.listPreviewImage}>
                        {post.imagebase64 ? <img alt='' style={{ width: "58px" }} src={post.imagebase64} /> : <></>}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <Typography>{post.title}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography>{post.description}</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography>Vote {post.hasYesNoQuestion ? 'Sì' : 'No'}</Typography>
                </Grid>
            </Grid>
        );
    }
    smallScreenLayout = (props: Iprops) => {
        const { post } = props;
        return (
            <Grid container className={props.classes.listItemContainer}>
                <Grid item xs={3}>
                    <div className={props.classes.listPreviewImage}>
                        {post.imagebase64 ? <img alt='' style={{ width: "58px" }} src={post.imagebase64} /> : <></>}
                    </div>
                </Grid>
                <Grid item xs={9}>
                    <div>
                        <Typography>{post.title}</Typography>
                        <Typography>{post.description}</Typography>
                        <Typography>Vote {post.hasYesNoQuestion ? 'Sì' : 'No'}</Typography>
                    </div>
                </Grid>
            </Grid>
        );
    }
    private loadVotes() {
        this.props.loadVotes(this.props.post._id);
        this.props.loadStatsVote(this.props.post._id);
    }

    render() {
        const { post, smallScreen, classes, key } = this.props;
        // const deliveredOn = new Date(post.deliveryDate)
        // const formatted = deliveredOn.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' }) + " " + deliveredOn.toLocaleTimeString('it-IT');
        return (
            <Grid container>
                <Grid item xs={12} key={key} >
                    <ExpansionPanel onChange={this.ChangeExpanded} elevation={0}>
                        <ExpansionPanelSummary className={classes.expansionPanelSummary}
                            classes={{
                                expandIcon: classes.expansionButton
                            }}
                            expandIcon={<Down className={classes.expansionButton} />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            {smallScreen ? this.smallScreenLayout(this.props) : this.fullScreenLayout(this.props)}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.expoansionPanelContent}>
                            <Grid container>
                                <Grid item sm={4}>
                                    {post.loaded ?
                                        <Preview htmlContent={post.htmlContent} imgBase64={post.imagebase64}></Preview>
                                        :
                                        <CircularProgress />
                                    }
                                </Grid>
                                {post.hasYesNoQuestion && (
                                    <Grid item sm={4}>
                                        <VoteGraph
                                            classes={this.props.classes}
                                            votestats={post.votestats}
                                            reloadVotes={this.loadVotes} />
                                    </Grid>
                                )}
                                {post.hasYesNoQuestion && post.votes &&
                                    <Grid item sm={4}>
                                        <Votes classes={this.props.classes} votes={post.votes} />
                                    </Grid>}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Grid>
            </Grid>
        );
    }
}
export const PostSentItem = WithMediaQuery(Comp)